import { Typography } from '@euler/app/components/typography';
import { memo } from 'react';
import { Pressable, View } from 'react-native';
import { useBoardUnit } from '../functions/useBoardUnit';
import { workshopBoardColors as colors } from '../workshopBoardColors';
import { WorkshopBoardMode } from '../workshopBoardMode';

const kModes: { mode: WorkshopBoardMode; title: string }[] = [
  { mode: 'tasks', title: '工单' },
  { mode: 'jobs', title: '施工' },
];

/** Which board shows: the open tasks or their construction jobs. */
export const ModeSwitch = memo(
  ({
    mode,
    onChange,
  }: {
    mode: WorkshopBoardMode;
    onChange: (mode: WorkshopBoardMode) => void;
  }) => {
    const u = useBoardUnit();
    return (
      <View
        style={{
          flexDirection: 'row',
          padding: u(4),
          borderRadius: u(12),
          backgroundColor: colors.card,
        }}
      >
        {kModes.map(item => {
          const on = item.mode === mode;
          return (
            <Pressable
              key={item.mode}
              accessibilityRole="button"
              accessibilityState={{ selected: on }}
              onPress={() => onChange(item.mode)}
              style={{
                paddingHorizontal: u(20),
                paddingVertical: u(8),
                borderRadius: u(9),
                backgroundColor: on ? colors.line : 'transparent',
              }}
            >
              <Typography.Text
                size={u(22)}
                medium
                color={on ? colors.foreground : colors.muted}
              >
                {item.title}
              </Typography.Text>
            </Pressable>
          );
        })}
      </View>
    );
  },
);
